import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { getQueryParams } from '@frontend/common/ph-router-store';
import { Store } from '@ngrx/store';
import { environment } from 'apps/check-in-kiosk/src/environments/environment';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'frontend-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false
})
export class FooterComponent {
  themeId$: ReplaySubject<number> = new ReplaySubject(1);
  currentYear = new Date().getFullYear();
  currentVersion = environment.version;

  constructor(private api: HttpClient, private store: Store) {
    this.getThemeConfig().subscribe(this.themeId$);
  }

  private getThemeConfig() {
    return this.api
      .get<{ theme: { id: number } }>('customers/current')
      .pipe(map((c) => {
        const themeId = c.theme?.id;
        if (typeof themeId === 'string') {
          return +themeId;
        }
        return themeId || 1;
      }));
  }

  get deviceID$() {
    return this.store.select(getQueryParams).pipe(map((c) => (c as any).device_id));
  }
}
